<!-- 产品服务-软件服务 -->

<template>


    <div class="software-page">

    <div class="h-c banner" data-text-reveal="off">

        <div class="software-banner-copy">

            <h1 class="text-size-72">

                {{ $t('Software.title1') }}<br>
                {{ $t('Software.title2') }}

            </h1>

            <div class="div-spacer-h16"></div>
            <p class="text-size-24">

                {{ $t('Software.description') }}

            </p>


        </div>

    </div>

    <div class="div-spacer-h288"></div>



    <div class="h-c" data-text-reveal="off">
        <div class="v-c">
            <h3 class="text-size-64" style="color: rgb(255, 255, 255);
        
        
        
        
        
        text-align: center;">

            {{ $t('Software.futureTitle') }}

        </h3>
        </div>
        
    </div>

    <div class="div-spacer-h16"></div>
    <div class="div-spacer-h16"></div>

    <div class="h-c" data-text-reveal="off">
        <div class="v-c">
            <h3 class="text-size-20" style="color: rgb(255, 255, 255);
        
        
        
        
        
        text-align: center;">

            {{ $t('Software.futureDesc') }}

        </h3>
        </div>
        
    </div>


    <div class="div-spacer-h80"></div>

    <div class="h-c" >
        <div class="v-c">
            <PictureCardAmplifier :src="require('@/assets/images/官网开发素材/software/B9320C50-F150-4D28-B99A-85C565136C5A.png')" :radius="15" fit="contain" :hoverScale="1"
                style="max-width: 621px;height: 351px;" />
            <div
                class="software-copy"
                data-text-reveal="off"
                style="display: flex;flex-direction: column;justify-content: left;gap: 16px;padding: 0px;max-width: 474px;">
                <h3 class="text-size-48" style="color: rgb(255, 255, 255);
                ">
                    {{ $t('Software.solution.title') }}
                </h3>
                <p class="text-size-16" style="color: rgb(255, 255, 255);
                ">
                    {{ $t('Software.solution.description') }}
                </p>
                <router-link to="/about/contact">
                    <AdapButtomBlack class="abb" :text="$t('Software.contactUs')" />
                </router-link>
                

            </div>
        </div>
    </div>

    <div class="div-spacer-h120"></div>

    <div class="h-c">
        <div class="v-c sec">
            
            <div
                class="software-copy"
                data-text-reveal="off"
                style="display: flex;flex-direction: column;justify-content: left;gap: 16px;max-width: 474px;">
                <h3 class="text-size-48" style="color: rgb(255, 255, 255);
                ">
                    {{ $t('Software.customization.title') }}
                </h3>
                <p class="text-size-16" style="color: rgb(255, 255, 255);
                ">
                    {{ $t('Software.customization.description') }}
                </p>
                <router-link to="/about/contact">
                    <AdapButtomBlack class="abb" :text="$t('Software.contactUs')" />
                </router-link>
                

            </div>
            <PictureCardAmplifier :src="require('@/assets/images/官网开发素材/software/p2.jpg')" :radius="15"
                style="max-width: 621px;height: 351px;" />
            
        </div>
    </div>





    <div class="div-spacer-h288"></div>



    </div>




</template>



<style scoped>
.software-page {
    background-color: rgb(0, 0, 0);
}

a{
    width: fit-content;
}

.software-copy {
    width: min(474px, 100%);
    flex: 0 1 474px;
}

.software-page :deep(.abb) {
    background-color: rgb(255, 255, 255) !important;
    border-color: rgb(255, 255, 255) !important;
    color: rgb(0, 0, 0) !important;
}



.banner {

    position: relative;
    background-image: url("@/assets/images/官网开发素材/banner/banner-product-software-chip.jpg");
    
    background-size: cover;
    /* 使背景图片覆盖整个 div */
    background-position: center top;
    /* 使背景图片居中 */
    background-repeat: no-repeat;
    /* 防止背景图片重复 */


}

.software-banner-copy {
    position: absolute;
    top: var(--space-banner-bottom-125);
    left: 50%;
    width: min(calc(100% - var(--pixso-page-padding) * 2), 936px);
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: rgb(255, 255, 255);
    text-align: center;
}

.software-banner-copy h1,
.software-banner-copy p {
    margin: 0;
    color: inherit;
    text-align: center;
}

@media (max-width: 768px) {

    .PictureCardAmplifier{
        
        height: 220px !important;
    }

    a{
        margin-top: 20px;
        align-self: center;
    }

    p{
        margin-top: 12px;
    }

    .abb{
        align-self: center;

    }

    .sec {
        flex-direction: column-reverse;
    }
}




</style>



<script setup>
// 添加h-c进入时的动画效果
import { useScrollAnimation } from '@/js/useScrollAnimation.js'
useScrollAnimation()
// 添加h-c进入时的动画效果
import AdapButtomBlack from '@/components/AdapButtomBlack.vue';
import PictureCardAmplifier from '@/components/PictureCardAmplifier.vue';

</script>
